(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.headerResizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        const borderBox = entry.borderBoxSize;
        const size = borderBox && (borderBox[0] || borderBox);
        const height = size ? size.blockSize : this.header.offsetHeight;
        if (height === this.headerHeight) return;
        this.headerHeight = height;
        cancelAnimationFrame(this.headerHeightFrame);
        this.headerHeightFrame = requestAnimationFrame(() => this.setHeaderHeight());
      });
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver.disconnect();
      cancelAnimationFrame(this.headerHeightFrame);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menovky-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ORIGIN='https://nametags.printhia.sk';
  (function(){ var ifr=document.querySelector('.menovky-cfg__iframe'); var tag=new URLSearchParams(location.search).get('tag'); if(ifr&&tag){ try{ var u=new URL(ifr.src); u.searchParams.set('tag',tag); var lng=new URLSearchParams(location.search).get('lang'); if(lng)u.searchParams.set('lang',lng); ifr.src=u.toString(); }catch(e){} } })();
  (function(){ var sk=document.getElementById('mc-skeleton'), ifr=document.querySelector('.menovky-cfg__iframe'); if(!sk||!ifr)return; var hide=function(){ if(!sk)return; sk.classList.add('is-hidden'); setTimeout(function(){ if(sk&&sk.parentNode){sk.parentNode.removeChild(sk);} sk=null; },550); }; ifr.addEventListener('load',hide); setTimeout(hide,8000); })();
  function root(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function confetti(){
    try{
      var c=document.createElement('canvas');
      c.style.cssText='position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483647';
      document.body.appendChild(c);
      var ctx=c.getContext('2d'),W=c.width=window.innerWidth,H=c.height=window.innerHeight;
      var cols=['#ff5f00','#ffb200','#16a34a','#3b82f6','#ec4899','#ffffff'],P=[];
      for(var i=0;i<150;i++){P.push({x:W/2,y:H*0.3,vx:(Math.random()-0.5)*9,vy:Math.random()*-11-3,g:0.17,s:6+Math.random()*6,r:Math.random()*6,vr:(Math.random()-0.5)*0.25,col:cols[i%cols.length]});}
      var t0=null,DUR=2800;
      function tick(ts){if(!t0)t0=ts;var t=ts-t0;ctx.clearRect(0,0,W,H);for(var j=0;j<P.length;j++){var p=P[j];p.vy+=p.g;p.x+=p.vx;p.y+=p.vy;p.r+=p.vr;ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.r);ctx.globalAlpha=Math.max(0,1-t/DUR);ctx.fillStyle=p.col;ctx.fillRect(-p.s/2,-p.s/2,p.s,p.s*0.6);ctx.restore();}if(t<DUR){requestAnimationFrame(tick);}else{c.remove();}}
      requestAnimationFrame(tick);
    }catch(e){}
  }
  function bump(){var b=document.querySelector('#cart-icon-bubble')||document.querySelector('.cart-count-bubble');if(!b)return;b.classList.remove('mc-bump');void b.offsetWidth;b.classList.add('mc-bump');}
  function toast(m){
    var el=document.createElement('div');el.textContent=m;
    el.style.cssText='position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(8px);background:#0a0a0a;color:#fff;font-weight:700;font-size:14px;padding:12px 18px;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.25);z-index:2147483647;opacity:0;transition:opacity .25s ease,transform .25s ease';
    document.body.appendChild(el);
    requestAnimationFrame(function(){el.style.opacity='1';el.style.transform='translateX(-50%) translateY(0)';});
    setTimeout(function(){el.style.opacity='0';setTimeout(function(){el.remove();},300);},2200);
  }
  function setInner(liveSel,html,freshSel,altSel){
    try{
      if(!html)return false;
      var live=document.querySelector(liveSel);
      if(!live)return false;
      var doc=new DOMParser().parseFromString(html,"text/html");
      var fresh=doc.querySelector(freshSel)||(altSel&&doc.querySelector(altSel))||doc.body.firstElementChild;
      if(!fresh)return false;
      live.innerHTML=fresh.innerHTML;
      return true;
    }catch(e){return false;}
  }
  function ack(src,origin,ok){try{src.postMessage({source:"menovky-host",type:"added",ok:!!ok},origin);}catch(e){}}
  window.addEventListener("message",function(e){
    if(e.origin!==ORIGIN)return;
    var d=e.data||{};
    if(d.source!=="menovky-configurator"||d.type!=="add")return;
    var item={id:d.id,quantity:d.quantity||1,properties:d.properties||{}};
    fetch(root()+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[item],sections:["cart-drawer","cart-icon-bubble"],sections_url:window.location.pathname})})
    .then(function(r){if(!r.ok){throw new Error("add "+r.status);}return r.json();})
    .then(function(res){
      confetti();
      var secs=res.sections||{};
      var html=secs["cart-drawer"];
      var drawer=document.querySelector("cart-drawer");
      var liveCD=document.getElementById("CartDrawer");
      var freshCD=null;
      if(html){try{freshCD=new DOMParser().parseFromString(html,"text/html").getElementById("CartDrawer");}catch(err){}}
      if(liveCD&&freshCD){liveCD.innerHTML=freshCD.innerHTML;}
      if(drawer){drawer.classList.remove("is-empty");}
      var inner=document.querySelector("#CartDrawer .drawer__inner");if(inner){inner.classList.remove("is-empty");}
      setInner("#cart-icon-bubble",secs["cart-icon-bubble"],".shopify-section","#cart-icon-bubble");
      var ov=document.getElementById("CartDrawer-Overlay");
      if(ov&&drawer){ov.addEventListener("click",function(){if(typeof drawer.close==="function"){drawer.close();}else{drawer.classList.remove("active");document.body.classList.remove("overflow-hidden");}});}
      if(drawer){if(typeof drawer.open==="function"){try{drawer.open();}catch(err){drawer.classList.add("animate","active");}}else{drawer.classList.add("animate","active");}document.body.classList.add("overflow-hidden");}
      ["cart:refresh","cart:update","cart:change","cart:added"].forEach(function(ev){try{document.dispatchEvent(new CustomEvent(ev,{detail:{}}));}catch(err){}});
      bump();
      if(!drawer){toast("Pridané do košíka");}
      ack(e.source,e.origin,true);
    })
    .catch(function(){ack(e.source,e.origin,false);});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
